// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/layout-and-structure/Offset.res.js:10"
  },
  offset: {
    "position-kVAEAm": "position-x10l6tqk",
    $$css: "wino-gc:src/resources/layout-and-structure/Offset.res.js:13"
  }
};
function styleProps(width, height) {
  return Stylex.props(styles.root, {
    height: String(height) + "px",
    width: String(width) + "px"
  });
}
function offsetStyleProps(top, right, bottom, left) {
  let tmp = {};
  let tmp$1 = Stdlib_Option.map(bottom, bottom => String(bottom) + "px");
  if (tmp$1 !== undefined) {
    tmp.bottom = Primitive_option.valFromOption(tmp$1);
  }
  let tmp$2 = Stdlib_Option.map(left, left => String(left) + "px");
  if (tmp$2 !== undefined) {
    tmp.left = Primitive_option.valFromOption(tmp$2);
  }
  let tmp$3 = Stdlib_Option.map(right, right => String(right) + "px");
  if (tmp$3 !== undefined) {
    tmp.right = Primitive_option.valFromOption(tmp$3);
  }
  let tmp$4 = Stdlib_Option.map(top, top => String(top) + "px");
  if (tmp$4 !== undefined) {
    tmp.top = Primitive_option.valFromOption(tmp$4);
  }
  return Stylex.props(styles.offset, tmp);
}
function Offset(props) {
  let __height = props.height;
  let __width = props.width;
  let width = __width !== undefined ? __width : 0;
  let height = __height !== undefined ? __height : 0;
  let match = styleProps(width, height);
  let match$1 = offsetStyleProps(props.top, props.right, props.bottom, props.left);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: props.children,
      className: match$1.className,
      style: match$1.style
    }),
    className: match.className,
    style: match.style
  });
}
let make = React.memo(Offset);
export { make };
/* styles Not a pure module */